<template>
	<iframe
		src="https://wholesale.wookah.pl/api/public/api/dossier"
		type="application/pdf"
		class="w-100 h-100 border-1s"
	>
		Oops! an error has occurred.
	</iframe>
</template>
<script>

export default {
	name: 'OtherDossier',
	components: {},
	computed: {},
	data: () => ({}),
	methods: {},
	created() {
	}
};
</script>
